import React, {Component} from 'react';
import {Empty, Modal,message} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";
import {downloadImg, uuid} from '../../../../utils'
export default class ImgChoose extends BaseComponent {
    static defaultProps = {
        imgAll: [],
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentCheckedPic: '',
            contentVisible: false,//正文选择
            checkedKey: 0,
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }


    render() {
        const {contentVisible} = this.state;
        const {imgAll} = this.props;
        // console.log(imgAll);
        if (!(imgAll && imgAll.length)){
            return <></>
        }
        return (
            <Modal title={'正文图片'} width={400} visible={contentVisible} onOk={() => {
                this.handleOkContent(this.state.currentCheckedPic)
            }}
                   onCancel={this.handleCancelContent}
                   bodyStyle={{height: 365}}>
                <Scrollbars style={{ width: 360}} autoHide>
                    <div>
                        {
                            imgAll ? (<div key={uuid()}>
                                {
                                    imgAll && imgAll.length && imgAll.map((item, index) => {
                                        return (
                                            <div key={uuid()} className={'checkedImg'}
                                                 style={{
                                                     padding: 3,
                                                     marginRight:20,
                                                     marginBottom: '24px',
                                                 }}
                                                 onClick={(e) => {
                                                     imgAll && imgAll.map(Item => {
                                                         imgAll[Item].currentChecked = false;
                                                     });
                                                     imgAll[item].currentChecked = !imgAll[item].currentChecked;
                                                     this.setState({currentCheckedPic: imgAll[item].getAttribute("source-url") || imgAll[item].getAttribute("src")})
                                                 }}>
                                                <img src={`${imgAll[item].getAttribute("source-url") || imgAll[item].getAttribute("src")}`}
                                                     key={item} style={{width: '330px', height: '198px',objectFit:"contain",border: '3px solid',
                                                    borderColor: this.state.currentCheckedPic && (imgAll[item].getAttribute("source-url") || imgAll[item].getAttribute("src")) == this.state.currentCheckedPic ? '#0050B3' : this.state.checkedKey == index ? '#0050B3' : "transparent",
                                                }} >
                                                </img>
                                            </div>
                                        )
                                    })
                                }
                            </div>) : <Empty/>
                        }

                        <style>
                            {`
                       .active{
                         border:1px solid red;
                       }
                    `}
                        </style>
                    </div>

                </Scrollbars>
            </Modal>
        )
    }

    // 显示
    showModal = () => {
        this.setState({contentVisible: true});
    };
    // 取消
    handleCancelContent = () => {
        this.setState({contentVisible: false});
    };
    //
    handleOkContent = (currentCheckedPic) => {
        let regExp = /^\/storage\/.*?$/;
        if(currentCheckedPic && !regExp.test(currentCheckedPic)) {
            Modal.confirm({
                title: '当前标题图是外链图片，请下载后手动上传。',
                content: '',
                okButtonProps: {
                    style: {display: "none"}
                },
                onOk: () => {
                    downloadImg(currentCheckedPic,"标题图");
                },
                onCancel() {
                },
                okText: "是",
                cancelText: "知道了",
            });
            return false;
        }
        if (currentCheckedPic) {
            this.props.getImgChoose && this.props.getImgChoose(currentCheckedPic)
        }
        this.setState({
            contentVisible: false
        })
    };
}